export default "__VITE_ASSET__DMLfnZBe__"